var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-blue-dark px-4 py-4 md:py-6"},[_c('FacetMenuCloseButton',{staticClass:"md:mt-3 mb-3"}),_c('h4',{staticClass:"text-white text-2xl font-bold"},[_vm._v(" "+_vm._s(_vm.translations.heading)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }